window.readFile = (file, format) => {
    let reader = new FileReader();

    return new Promise((resolve, reject) => {
        reader.onload = event => {
            resolve(event.target.result);
        };

        reader.onerror = () => {
            return reject(this);
        };

        if (format === 'binary') {
            reader.readAsBinaryString(file);
        }
        else if (format === 'base64') {
            reader.readAsDataURL(file);
        }
        else if (format === 'text') {
            reader.readAsText(file);
        }
        else if (/^image/.test(file.type)) {
            reader.readAsDataURL(file);
        } else {
            reader.readAsText(file);
        }
    });
};
